import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ConsultantSearchConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ConsultantSearchService } from './api/consultantSearch.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConsultantSearchApiModule {
    public static forRoot(configurationFactory: () => ConsultantSearchConfiguration): ModuleWithProviders<ConsultantSearchApiModule> {
        return {
            ngModule: ConsultantSearchApiModule,
            providers: [ { provide: ConsultantSearchConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConsultantSearchApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConsultantSearchApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
